// root '../../../';

// dependencies
import { Child } from 'pym.js';
import { select } from 'd3-selection';
import { json } from 'd3-fetch';

// polyfills
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic
import config from './config';
import graphic from './graphic';

// styles
import './styles/index.scss';

/* develblock:start */
import meta from './data/meta.json';

const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

window.onload = () => {
  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);
      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }
};

let chartData = null;
const DATA_URL = 'https://ix.cnn.io/data/ebola/ebola_outbreaks.json';

// Init pym immediately so the parent can send width events.
// draw() is a no-op until chartData is populated.
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

// Fetch live data, then trigger an initial render.
json(DATA_URL)
  .then((response) => {
    chartData = response.data;
    const container = document.getElementById('graphic');
    draw((container && container.clientWidth) || 600);
  })
  .catch((err) => {
    console.error('Failed to load Ebola outbreak data:', err);
  });

function draw(initialWidth) {
  if (!chartData) return;

  const container = select('#graphic');
  container.html('');

  const fallbackWidth = container.node().clientWidth || 600;
  const safeWidth = initialWidth !== fallbackWidth ? fallbackWidth : initialWidth;
  const isMobile = safeWidth <= 500;

  const props = { initialWidth: safeWidth, isMobile };

  const graphicConfig = config(props, chartData);
  graphic(graphicConfig, container, isMobile);

  if (window.pymChild) {
    window.pymChild.sendHeight();
  }
}
